<template>
    <div
        class="drag-ball"
        draggable="true"
        @dragstart="dragstart($event)"
        @dragend="dragend($event)"
        :style="`right:${elRight}px;bottom:${elBottom}px`"
    >
        <el-progress width="82" type="circle" :percentage="gailv" :stroke-width="1" :color="'#E93A29'">
            <template #default="{ percentage }">
                <span style="color:#E93A29;font-size: 18px;font-weight: bold;">{{ percentage }}%</span>
            </template>
        </el-progress>
    </div>
</template>
<script>
export default {
    name: 'dragball',
    data() {
        return {
            startclientX: 0,
            startclientY: 0,
            elRight: 55,
            elBottom: 110,
        }
    },
    props: {
        gailv: String, // 保
    },
    methods: {
        dragstart(e) {
            this.startclientX = e.clientX;
            this.startclientY = e.clientY;
        },
        dragend(e) {
            //console.log("eeeeee", e);
            let x = this.startclientX - e.clientX;
            let y = this.startclientY - e.clientY;
            this.elRight += x;
            this.elBottom += y;
        }
    }
}
</script>
<style scoped>
.drag-ball {
    cursor: all-scroll;
    position: fixed;
    width: 80px;
    height: 80px;
    bottom: 110px;
    right: 0;
    background-color: white;
    border-radius: 50%;
    text-align: center;
    color: white;
    font-size: 16px;
    line-height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 9999;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.3)
}
</style>
